import React from 'react';
import { AGENT_RENDERERS } from './renderers/AgentRenderers';
import CopyButton from './renderers/CopyButton';

interface ResponseRendererProps {
  agentType?: string;
  agentOutput?: any;
}

const ResponseRenderer: React.FC<ResponseRendererProps> = ({ agentType, agentOutput }) => {
  console.log('ResponseRenderer called:', { agentType, hasOutput: !!agentOutput });

  // If no agent output, render as plain text
  if (!agentOutput) {
    return <div className="text-gray-800">{agentOutput}</div>;
  }

  // Get the appropriate renderer using only the provided agent_type
  const RendererComponent = AGENT_RENDERERS[agentType as keyof typeof AGENT_RENDERERS];

  // If no specific renderer found, render as plain text
  if (!RendererComponent) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-3">
        <div className="text-gray-800 whitespace-pre-wrap">
          {JSON.stringify(agentOutput, null, 2)}
        </div>
        <CopyButton agentType={agentType} agentOutput={agentOutput} />
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <RendererComponent data={agentOutput} />
      <CopyButton agentType={agentType} agentOutput={agentOutput} />
    </div>
  );
};

export default ResponseRenderer;
